import React from 'react';

const uniqid = require('uniqid');

class StepBar extends React.Component {

  render() {
    const currentStep = (+(this.props.info.currentStep)) - 1;
    const steps = [];

    for (let i = 0; i < this.props.info.total; i++) {
      if (i <= currentStep) {
        steps.push(<span style={{width: this.props.customWidth ? this.props.customWidth : '24%', height:'2px'}} className="stepBarGlobal active" key={uniqid('stepBar_')} 
         />);
      } else {
        steps.push(<span style={{width: this.props.customWidth ? this.props.customWidth : '24%', height:'2px'}} className="stepBarGlobal" key={uniqid('stepBar_')} />);
      }

      if ((i !== this.props.info.total - 1) && this.props.isAddSpacer) {
        steps.push(<span width="2px">&nbsp;</span>);
      }

    }

    return (
      <div className={`steps${this.props.customStepsCss ? this.props.customStepsCss : ''}`} id="headerSteps">
        <div className="stepBarContainer" key={uniqid()}>
          {steps}
        </div>
        <div className="stepContainer"><span className="currentCount">{this.props.info.currentStep} </span><span className="lastCount">{this.props.info.total && `de ${this.props.info.total}`}</span></div>
      </div>
    );
  }


}
export default StepBar;
